import React from "react";

function PartnerPerformance({ table_data, partner_id, partner_name }) {
  let data = [];
  let userLoging = {};
  let currencies = [];
  userLoging = JSON.parse(localStorage.getItem("user") || "{}");
  currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
  const defaultCurrencyId = Number(userLoging?.default_currency_id || 1);
  const selectedCurrency = currencies.find(
  (currency) =>
    Number(currency.value) === defaultCurrencyId
);
  const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
  const currencyType = defaultCurrencyId === 1 ? "en-IN" : "en-US";
  const amountSuffix = defaultCurrencyId === 1 ? "Cr" : "K";
  const amountDivisor = defaultCurrencyId === 1 ? 10000000 : 1000;
  
  const business_delivered = table_data?.business_delivered || [];
  const business_generated = table_data?.business_generated || [];
  const self_bd_delivered = table_data?.self_bd_delivered || [];
  const last_year_business_generated =
    table_data?.last_year_business_generated || [];
  const partner_net_add = table_data?.partner_net_add || [];
  const partner_net_add_current_month =
    table_data?.partner_net_add_current_month || [];

  for (let i = 0; i < business_delivered.length; i++) {
    const shared_delivery =
      business_delivered[i]?.total_revenue -
      self_bd_delivered[i]?.total_revenue;
    data.push({
      partner_id: business_delivered[i]?.id,
      partner:
        business_delivered[i]?.firstname +
        " " +
        business_delivered[i]?.lastname,
      business_generated: business_generated[i]?.total_revenue
        ? (business_generated[i]?.total_revenue / amountDivisor).toFixed(2)
        : 0,
      net_add: partner_net_add[i]?.net_add
        ? (partner_net_add[i]?.net_add / amountDivisor).toFixed(2)
        : 0,
      partner_net_add_current_month: partner_net_add_current_month[i]
        ?.net_add_curr_mon
        ? (
            partner_net_add_current_month[i]?.net_add_curr_mon / amountDivisor
          ).toFixed(2)
        : 0,
      business_delivered: business_delivered[i]?.total_revenue
        ? (business_delivered[i]?.total_revenue / amountDivisor).toFixed(2)
        : 0,
      self_bd_delivered: self_bd_delivered[i]?.total_revenue
        ? (self_bd_delivered[i]?.total_revenue / amountDivisor).toFixed(2)
        : 0,
      shared_delivery: shared_delivery
        ? (shared_delivery / amountDivisor).toFixed(2)
        : 0,
      other_partner_delivered: business_generated[i]?.total_revenue
        ? (
            (business_generated[i]?.total_revenue -
              self_bd_delivered[i]?.total_revenue) /
            amountDivisor
          ).toFixed(2)
        : 0,
      self_delivery_percentage: self_bd_delivered[i]?.total_revenue
        ? (
            (self_bd_delivered[i]?.total_revenue /
              business_generated[i]?.total_revenue) *
            100
          ).toFixed(2)
        : "0.00",
      shared_delivery_percentage: shared_delivery
        ? (
            (shared_delivery / business_delivered[i]?.total_revenue) *
            100
          ).toFixed(2)
        : "0.00",
      self_gen_growth_percentage: business_generated[i]?.total_revenue
        ? (
            ((business_generated[i]?.total_revenue -
              last_year_business_generated[i]?.total_revenue) /
              last_year_business_generated[i]?.total_revenue) *
            100
          ).toFixed(2)
        : "0.00",
    });
  }

  return (
    <>
      <style>
        {`
                    .table thead tr th {
                        white-space: normal !important;
                        word-wrap: break-word;
                        padding: 6px 8px;
                    }
                    
                    .table tbody tr td {
                    color : #202c4b;
                    }
                `}
      </style>
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead>
            <tr>
              <th>Partner</th>
              <th>
                Business Generated{" "}
                <i
                  className="fa fa-solid fa-info-circle"
                  title="Total value of business (search fees) originated by the Partner, regardless of who delivers the searches"
                ></i>
              </th>
              <th>Net Add</th>
              <th>
                Net Add{" "}
                <i
                  className="fa fa-solid fa-calendar"
                  title="Current Month Net Add"
                ></i>
              </th>
              <th>
                Business Delivered{" "}
                <i
                  className="fa fa-solid fa-info-circle"
                  title="Total value of business (search fees) delivered by the Partner, including both their own generated business and business generated by other Partners."
                ></i>
              </th>
              <th>
                Self BD Delivered{" "}
                <i
                  className="fa fa-solid fa-info-circle"
                  title="Total value of business that the Partner both generated and delivered."
                ></i>
              </th>
              <th>
                Referred Business{" "}
                <i
                  className="fa fa-solid fa-info-circle"
                  title="Total value of business delivered by the Partner that was generated by other Partners."
                ></i>
              </th>
              <th>
                Other Partner Delivered{" "}
                <i
                  className="fa fa-solid fa-info-circle"
                  title="Total value of business generated by the Partner that was delivered by other Partners."
                ></i>
              </th>
              <th>
                Self-Delivery %{" "}
                <i
                  className="fa fa-solid fa-info-circle"
                  title="Percentage of the Partner’s generated business that they delivered themselves. 
                  Formula: Self BD Delivered ÷ Business Generated"
                ></i>
              </th>
              <th>
                Shared-Delivery %{" "}
                <i
                  className="fa fa-solid fa-info-circle"
                  title="Percentage of the Partner’s delivered business that comes from searches generated by other Partners.
                  Formula: Shared Delivery ÷ Business Delivered"
                ></i>
              </th>
              <th>
                Self Gen Growth %{" "}
                <i
                  className="fa fa-solid fa-info-circle"
                  title="Year-on-year growth in the Partner’s self-generated business for the corresponding period."
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 &&
              data?.map((item, index) => {
                return (
                  <tr
                    onClick={() => {
                      partner_id(item?.partner_id);
                      partner_name(item?.partner);
                    }}
                    key={index}
                    style={{ cursor: "pointer" }}
                  >
                    <td>
                      <h6 className="fw-medium">{item?.partner}</h6>
                    </td>
                    <td>
                      <h6 className="fw-medium">{`${symbol} ${item?.business_generated} ${amountSuffix}`}</h6>
                    </td>
                    <td>
                      <h6 className="fw-medium">{`${symbol} ${item?.net_add} ${amountSuffix}`}</h6>
                    </td>
                    <td>
                      <h6 className="fw-medium">{`${symbol} ${item?.partner_net_add_current_month} ${amountSuffix}`}</h6>
                    </td>
                    <td>{`${symbol} ${item?.business_delivered} ${amountSuffix}`}</td>
                    <td>{`${symbol} ${item?.self_bd_delivered} ${amountSuffix}`}</td>
                    <td>{`${symbol} ${item?.shared_delivery} ${amountSuffix}`}</td>
                    <td>{`${symbol} ${item?.other_partner_delivered} ${amountSuffix}`}</td>
                    <td>
                      <span
                        className={`badge rounded-pill ${
                          parseInt(item?.self_delivery_percentage) > 0
                            ? "bg-success"
                            : "bg-danger"
                        }`}
                      >
                        {item?.self_delivery_percentage}%
                      </span>
                    </td>
                    <td>
                      <span
                        className={`badge rounded-pill ${
                          parseInt(item?.shared_delivery_percentage) > 0
                            ? "bg-success"
                            : "bg-danger"
                        }`}
                      >
                        {item?.shared_delivery_percentage}%
                      </span>
                    </td>
                    <td>
                      <span
                        className={`badge rounded-pill ${
                          parseInt(item?.self_gen_growth_percentage) > 0
                            ? "bg-success"
                            : "bg-danger"
                        }`}
                      >
                        {item?.self_gen_growth_percentage}%
                      </span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default PartnerPerformance;
